<template>
  <div class="control-section card-control-section basic_card_layout">
    <div class="e-card-resize-container">
      <div class="row">
        <div class="row card-layout"  style="height: calc(100vh - 108px);overflow: auto;">
          <div  v-for="(item, index) of data" v-bind:key=index class="col-xs-6 col-sm-6 col-lg-4 col-md-6" style="margin-top:15px; margin-bottom:15px;">
            <div tabindex="0" class="e-card" id="basic_card" style="border:none">
              <div class="e-card-content" >
                <div class="text-align" style="height:42px;border-bottom:1px solid #eee;margin-bottom: 10px;">
                    <div
                      style="float:left;line-height: 40px;float: left;font-size: 18px;text-indent: 5px;color: #1890ff;"
                     :title="item.name">{{item.name.length > 15 ? item.name.substr(0,15) + "..." : item.name}}</div>
                  <div class='h-toolbarBg'>
                    <ejs-toolbar style="float:right;">
                      <button
                        class="e-btn e-tbar-btn icon hero-icon hero-icon-synchronize"
                        :title='$t("DeployManagement.synchronization")'
                        @click="syncTopoNodes(item)"
                      />
                      <button class="e-btn e-tbar-btn icon hero-icon hero-icon-confirm" :title='$t("DeployManagement.oneKeyDeployed")' @click='getDeployTemplate(item)'/>
                      <button class="e-btn e-tbar-btn icon hero-icon hero-icon-details" :title='$t("DeployManagement.deployedDetail")' @click='getDeployInstance(item)'/>
                      <button class="e-btn e-tbar-btn icon hero-icon hero-icon-batch-add" :title='$t("DeployManagement.batchUpgrade")' @click='batchUpDp(item)'/>
                      <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-search-history" :title='$t("DeployManagement.upgradeHistory")' @click='upgradeHitory(item)'/>-->
                      <button class="e-btn e-tbar-btn icon hero-icon hero-icon-export" :title='$t("DeployManagement.exportXml")' @click='exportDpTemplate(item)'/>
                      <button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title='$t("DeployManagement.delete")' @click='delDPEnviroment(item)'/>


                    </ejs-toolbar>
                  </div>
                </div>
                <div style="text-indent: 5px;line-height: 32px;margin-top: 15px;color:#bbb;">
                  {{$t('DeployManagement.environmentName')}}：<span style="color: #333333;font-size: 16px;" :title='item.name'>{{item.name.length > 15 ? item.name.substr(0,15) + "..." : item.name}}</span>
                </div>
                <div style="text-indent: 5px;line-height: 32px;color:#bbb;">
                  {{$t('DeployManagement.environmentIP')}}：<span style="color: #333333;font-size: 16px;">{{item.dpIp}}</span>
                </div>
                <div style="text-indent: 5px;line-height: 32px;color:#bbb;">
                  {{$t('DeployManagement.environmentPort')}}：<span style="color: #333333;font-size: 16px;">{{item.dpPort}}</span>
                </div>
                <div style="text-indent: 5px;line-height: 32px;color:#bbb;">
                  {{$t('DeployManagement.productVersion')}}：<span style="color: #333333;font-size: 16px;">{{item.productVersion}}</span>
                </div>
                <div style="text-indent: 5px;line-height: 32px;color:#bbb;">
                  {{$t('DeployManagement.dpSoftVersion')}}：<span style="color: #333333;font-size: 16px;">{{item.dpSoftVersion}}</span>
                </div>
                <!--<div style="text-indent: 5px;line-height: 32px;color:#bbb;">
                  模板形态：<span style="color: #333333;font-size: 16px;">{{item.deploymentNorm}}</span>
                </div>-->
                <div style="text-indent: 5px;line-height: 32px;color:#bbb;">
                  {{$t('DeployManagement.createTime')}}：<span style="color: #333333;font-size: 16px;">{{item.createTime }}</span>
                </div>
              </div>

            </div>
          </div>

          <div class="col-xs-6 col-sm-6 col-lg-4 col-md-6" style="margin-top:15px; margin-bottom:15px;">
            <div tabindex="0" class="e-card" id="basic_card">
              <div class="e-card-actions k8s-bg" style="height:200px;background-position: center;text-align:center;"  @click="addDPEnviroment"></div>
              <!--<div class="e-card-actions">
                <button class="e-btn e-outline e-primary" @click='addDPEnviroment'>
                  Add More
                </button>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomDialog ref='addDPEnviromentPage' :element='dialog.element.eleAddDpEnviroment' :styles='dialog.styles' :messages='dialog.messages.addDpEnviroment'>
      <template v-slot:dialog-content>
        <AddDPEnviroment ref='addDPEnviromentDialog'></AddDPEnviroment>
      </template>
    </CustomDialog>
    <CustomDialog ref='oneKeyDeploymentPage' :element='dialog.element.eleDeployment' :styles='dialog.deployStyles' :messages='dialog.messages.addDeployment'>
      <template v-slot:dialog-content>
        <!--<OneKeyDeployment ref='oneKeyDeploymentDialog'></OneKeyDeployment>-->
        <OneKeyDeploymentEdit ref='oneKeyDeploymentDialog'></OneKeyDeploymentEdit>
      </template>
    </CustomDialog>
    <CustomDialog ref='deployedInstancePage' :element='dialog.element.eleDeployedInstance' :styles='dialog.deployedInstanceStyles' :messages='dialog.messages.addDeployedInstance'>
      <template v-slot:dialog-content>
       <!-- <Table ref="deployedInstanceDialog" :qryParam="qryParam"></Table>-->
        <DPInstanceDetail ref="deployedInstanceDialog"></DPInstanceDetail>

      </template>
    </CustomDialog>
    <CustomDialog ref='upgradeVersions' :element='dialog.element.eleUpgradeVersion' :styles='dialog.upgradeVersionStyles' :messages='dialog.messages.batchUpgradeDp'>
      <template v-slot:dialog-content>
        <UpgradeVersion ref="upgradeVersionsDialog"></UpgradeVersion>
      </template>
    </CustomDialog>
    <CustomDialog ref='upgradeInfos' :element='dialog.element.eleUpgradeInfo' :styles='dialog.upgradeVersionStyles' :messages='dialog.messages.upgradeInfo'>
      <template v-slot:dialog-content>
        <UpgradeInfos ref="upgradeInfosDialog"/>
      </template>
    </CustomDialog>
    <ejs-dialog :buttons='confirmDlgButtons' ref="confirmDialog" v-bind:visible="false" :header='confirmHeader' :animationSettings='animationSettings' :content='confirmContent' :showCloseIcon='confirmCloseIcon'
                :width='confirmWidth' :height='confirmHeight' :isModal='true'>
    </ejs-dialog>
  </div>
</template>
<script>
import CustomDialog from '../../../common/CustomDialog';
import AddDPEnviroment from './dialog/AddDPEnviroment';
import OneKeyDeployment from './dialog/OneKeyDeployment';
import Table from '../../serverManagement/Table';
import DPInstanceDetail from './dialog/DPInstanceDetail';
import { EventBus } from '../../../../plugins/eventBus';
import OneKeyDeploymentEdit from './dialog/OneKeyDeploymentEdit';
import UpgradeVersion from "./dialog/UpgradeVersion";
import UpgradeInfos from "./dialog/UpgradeInfos";

export default {
  name: 'DPEnvironmentPanel',
  components: {
    UpgradeInfos,
    UpgradeVersion,
    DPInstanceDetail,
    CustomDialog,
    AddDPEnviroment,
    OneKeyDeployment,
    Table,
    OneKeyDeploymentEdit
  },
  props: [
    'id'
  ],
  data() {
    return {
      queryTopoTimer: undefined,
      confirmHeader: this.$t('DeployManagement.syncTopoInfo'),
      confirmContent: '',
      confirmCloseIcon: true,
      confirmWidth: '500px',
      confirmHeight: '300px',
      animationSettings: { effect: 'None' },
      confirmDlgButtons: [{ click: this.confirmDlgBtnCancellClick, buttonModel: { content: this.$t('Spectrum.ui_cancell') } }],
      panelId: this.id,
      widthNum: 3,
      data: {},
      deleteEnv: {},
      batchUpDpParam:{},
      selectedServ:[],
      qryParam: {
        envID: ''
      },
      dialog: {
        styles: {
          width: '40%',
          height: '70%',
          visible: false,
          model: true
        },
        deployStyles: {
          width: '60%',
          height: '90%',
          visible: false,
          model: true
        },
        deployedInstanceStyles: {
          width: '70%',
          height: '90%',
          visible: false,
          model: true
        },
        upgradeVersionStyles: {
          width: '70%',
          height: '70%',
          visible: false,
          model: true
        },
        element: {
          eleDeployment: {
            target: this.$refs.deployBtn,
            refName: 'eleDeployment',
            buttonGroup: [
              { click: this.closeOneKeyDeploymentPage, buttonModel: { content: this.$t('UE.ueCancell') } },
              { click: this.saveDeployTemplate, buttonModel: { content: this.$t('DeployManagement.saveButton'), isPrimary: true } },
              { click: this.oneKeyDeployment, buttonModel: { content: this.$t('DeployManagement.deployButton'), isPrimary: true } }
            ],
            title: this.$t('DeployManagement.oneKeyDeployed'),
            isClose: true
          },
          eleAddDpEnviroment: {
            target: this.$refs.grid,
            refName: 'eleAddDpEnviroment',
            buttonGroup: [
              { click: this.closeDPEnviromentPage, buttonModel: { content: this.$t('UE.ueCancell') } },
              { click: this.createEnvironment, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: this.$t('DeployManagement.addDpEnvironment'),
            isClose: true
          },
          eleDeployedInstance: {
            target: this.$refs.deployBtn,
            refName: 'eleDeployedInstance',
            buttonGroup: [
              { click: this.closeDeployedInstancePage, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: this.$t('DeployManagement.deployedDetail'),
            isClose: true
          },
          eleUpgradeVersion: {
            refName: 'eleUpgradeVersion',
            buttonGroup: [
              { click: this.closeUpgradeVersion, buttonModel: { content: this.$t('TS.ts_cancell') } },
              { click: this.doUpgradeVersion, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: this.$t('DeployManagement.batchUpgrade'),
            isClose: true
          },
          eleUpgradeInfo: {
            refName: 'upgradeInfos',
            buttonGroup: [
              { click: this.closeUpgradeInfos, buttonModel: { content: this.$t('TS.ts_cancell')} }
            ],
            title: this.$t('DeployManagement.upgradeStatus'),
            isClose: true
          }
        },
        messages: {
          addDpEnviroment: {
            title: this.$t('DeployManagement.addDpEnvironment')
          },
          addDeployment: {
            title: this.$t('DeployManagement.oneKeyDeployed')
          },
          addDeployedInstance: {
            title: this.$t('DeployManagement.deployedStatus')
          },
          batchUpgradeDp: {
            title: this.$t('DeployManagement.batchUpgrade')
          },
          upgradeInfo: {
            title: this.$t('DeployManagement.upgradeStatus')
          },
        }
      }
    };
  },
  methods: {
    closeOneKeyDeploymentPage() {
      this.$refs.oneKeyDeploymentPage.clear();
      this.$refs.oneKeyDeploymentPage.close();
    },
    closeCreateEnvironmentPage() {
      this.$refs.addDPEnviromentPage.clear();
      this.$refs.addDPEnviromentPage.close();
    },
    closeDeployedInstancePage() {
      this.$refs.deployedInstancePage.clear();
      this.$refs.deployedInstancePage.close();
    },
    closeUpgradeVersion() {
      this.$refs.upgradeVersions.clear();
      this.$refs.upgradeVersions.close();
      this.batchUpDpParam={};
      this.selectedServ = [];
    },
    closeUpgradeInfos() {
      this.$layer.confirm({
        msg: this.$t('DeployManagement.qryUpgradeInfo'),
        btn1: { msg: this.$t('MML.cancel')},
        btn2: {
          msg: this.$t('MML.confirm'),
          func: ()=>{
            this.$refs.upgradeInfos.clear();
            this.$refs.upgradeInfos.close();
            this.getGridData();
          }
        },
      });

    },
    createEnvironment() {
      if (!this.$refs.addDPEnviromentDialog.validate()) return;
      this.$loading.showLoadding(this.$t('DeployManagement.addingEnviroment'));
      const params = this.$refs.addDPEnviromentDialog.getData();
      this.$axios.post('/lte/ems/env/createEnvironment.html', params).then((response) => {
        this.$loading.hideLoadding();
        this.closeCreateEnvironmentPage();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          } else if (response.data.errorCode === '10001') {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.nameAndIPSame') });
          } else if (response.data.errorCode === '2609') {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
          }else {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.addEnvironmentFailed') });
          }
        }
      });
    },
    iPFormat(grids, data) {
      const content = JSON.parse(data.content);
      return content.dpIp;
    },
    portFormat(grids, data) {
      const content = JSON.parse(data.content);
      return content.dpPort;
    },
    productFormat(data) {
      const content = JSON.parse(data.content);
      if (content.product === 0) {
        return '3000';
      }
      if (content.product === 1) {
        return '6000';
      }
      if (content.product === 2) {
        return '9000';
      }
      return '9000';
    },
    deploymentNormFormat(data) {
      const content = JSON.parse(data.content);
      if (content.deploymentNorm === 0) {
        return '单机单点';
      }
      if (content.deploymentNorm === 1) {
        return '单机集群';
      }
      if (content.deploymentNorm === 2) {
        return '单主多从最小规格';
      }
      if (content.deploymentNorm === 3) {
        return '单主多从中等规格';
      }
      if (content.deploymentNorm === 4) {
        return '单主多从大型规格';
      }
      if (content.deploymentNorm === 5) {
        return '双主多从最小规格';
      }
      if (content.deploymentNorm === 6) {
        return '双主多从中等规格';
      }
      if (content.deploymentNorm === 7) {
        return '双主多从大型规格';
      }
      if (content.deploymentNorm === 8) {
        return '自定义';
      }
      return '自定义';
    },
    addDPEnviroment() {
      this.$refs.addDPEnviromentDialog.getDpVersionList();
      this.$refs.addDPEnviromentDialog.getProductVersionList();
      this.$refs.addDPEnviromentPage.show();
    },
    getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const dpIds = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        dpIds.push(checkedData[i].dpId);
      }
      return dpIds.length === 0 ? false : dpIds;
    },
    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOne') });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOne') });
        return false;
      }
      return selectedRecords;
    },
    getDeployTemplate(item) {
      this.$refs.oneKeyDeploymentPage.show();
      this.$refs.oneKeyDeploymentDialog.getTemplateContent(item);
      this.$refs.oneKeyDeploymentDialog.getDeployTemplate(item);
      this.$refs.oneKeyDeploymentDialog.getDeployedResult();
    },
    syncTopoNodes(item) {
      this.$loading.showLoadding(this.$t('DeployManagement.getingTopoInfo'));
      const params = {
        info: {
          processName: 'ems_micropoc',
          ip: item.dpIp,
          port: item.dpPort,
          id: item.id
        },
        vo: ''
      };
      this.$axios.post('/lte/ems/nf/getTopologyNode.html', params).then((response) => {
        this.$loading.hideLoadding();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
            if (response.data.resultVal !== null && response.data.resultVal.trim().length > 0) {
              this.confirmContent = `<div style="height:180px;width:450px;word-wrap:break-word;">${this.$t('DeployManagement.saveTopoInfoFailed')}：${response.data.resultVal}</div>`;
              this.confirmBtnClick();
              /*this.$layer.confirm({
                //msg: this.$t('删除实例'),
                msg: `服务包不存在：${response.data.resultVal}`,
                btn1: {
                  msg: this.$t('System.confirm')
                }
              });*/
            }
          } /*else if (response.data.errorCode === '13') {
            EventBus.$emit('toast', { type: 'warning', content: 'DP服务不可用' });
          } */else {
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        }
      });
    },
    test() {
      this.$refs.oneKeyDeploymentPage1.show();
    },
    saveDeployTemplate() {
      const params = this.$refs.oneKeyDeploymentDialog.getData();
      if (params.vo === null) {
        this.closeOneKeyDeploymentPage();
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.emptyTemplate') });
        return;
      }
      this.$loading.showLoadding(this.$t('DeployManagement.savingDeploymentTemplate'));

      this.$axios.post('/lte/ems/nf/saveDeployTemplate.html', params).then((response) => {
        this.$loading.hideLoadding();
        this.closeOneKeyDeploymentPage();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          } else {
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        }
      });
    },
    oneKeyDeployment() {
      const params = this.$refs.oneKeyDeploymentDialog.getData();
      if (params.vo === null) {
        this.closeOneKeyDeploymentPage();
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.emptyTemplate') });
        return;
      }
      //this.queryTopoTimer = setInterval(this.timeOutGetTopo, 6000, params);
      this.$loading.showLoadding(this.$t('DeployManagement.deploying'));
      this.$axios.post('/lte/ems/nf/deploy.html', params).then((response) => {
        this.$loading.hideLoadding();
        this.closeOneKeyDeploymentPage();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
            if (response.data.resultVal !== null && response.data.resultVal.trim().length > 0) {
              this.confirmContent = `<div style="height:180px;width:450px;word-wrap:break-word;">${this.$t('DeployManagement.saveTopoInfoFailed')}：${response.data.resultVal}</div>`;
              this.confirmBtnClick();
            }
            this.queryTopoTimer = setInterval(this.timeOutGetTopo, 60000, params);
          } /* else if (response.data.errorCode === '13') {
            EventBus.$emit('toast', { type: 'warning', content: 'DP服务不可用' });
          } */ else {
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        }
      });
    },
    confirmDlgBtnCancellClick() {
      this.$refs.confirmDialog.hide();
    },
    confirmBtnClick() {
      this.$refs.confirmDialog.show();
    },
    timeOutGetTopo(params) {
      const deployedCount = this.$refs.deployedInstanceDialog.deployedInstanceCount;
      if ((deployedCount.indexOf('/') > 0) && (deployedCount.split('/')[0] === deployedCount.split('/')[1])) {
        const item = {
          dpIp: params.info.ip,
          dpPort: params.info.port,
          id: params.info.id
        };
        const timer1 = setTimeout(() => {
          this.syncTopoNodes(item);
        }, 60000);
        clearInterval(this.queryTopoTimer);
      }
    },
    getDeployInstance(item) {
      this.$refs.deployedInstancePage.show();
      // const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.qryParam.envID = item.id;
      //this.$refs.deployedInstanceDialog.init(2);
      this.$refs.deployedInstanceDialog.initTable(item);
    },
    delDPEnviroment(item) {
      this.deleteEnv = item;
      this.$layer.confirm({
        msg: this.$t('Topo.sureDel'),
        btn1: {
          msg: this.$t('Topo.cancel')
        },
        btn2: {
          msg: this.$t('Topo.confirm'),
          func: this.delDp
        }
      });
    },
    upgradeHitory(item){
      const param = {envId:item.id};
      this.$loading.showLoadding(this.$t('DeployManagement.searchUpgrade'));
      this.$loading.hideLoadding();
    },
    batchUpDp(item){
      const param = {};
      param['envId']= item.id;
      param['product'] = item.productType;
      param['productVersion'] = item.productVersion;
      this.$loading.showLoadding(this.$t('DeployManagement.searchUpgrade'));
      this.axios.post('/lte/ems/packageManager/checkBatchUpGradeDp', param).then((res) =>{
        this.$loading.hideLoadding();
        if(res.data.errorCode == 'SUCCESS'){
          const data = res.data.resultVal;
          const versions = [];
          const versionMap = new Map();
          data.forEach(map =>{
            for (let key in map){
              versions.push({text:key,value:key});
              versionMap.set(key, map[key]);
            }
          });
          if(versions.length == 0){
            EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.noUpgradeVer') });
            return false;
          }
          const param ={};
          param.data = versionMap;
          param.envId = item.id;
          param.versions = versions;
          this.$refs.upgradeVersionsDialog.setVersionData(param);
          this.$refs.upgradeVersions.show();
        }else{
          EventBus.$emit('toast', { type: 'error', content: res.data.errorString });
        }
      });
    },
    doUpgradeVersion(){
      if(this.batchUpDpParam.ids == undefined){
        EventBus.$emit('toast', { type: 'warning', content:this.$t('DeployManagement.pleaseSelectOneData')  });
        return false;
      }
      this.$loading.showLoadding(this.$t('DeployManagement.searchUpgrade'));
      this.axios.post('/lte/ems/packageManager/batchUpGradeDp', this.batchUpDpParam,{timeout: 60 * 4 * 1000}).then((res) =>{
        this.$loading.hideLoadding();
        if(res.data.errorCode == 'SUCCESS'){
          this.$refs.upgradeInfosDialog.setUpgradeInfo({envId:this.batchUpDpParam.envId, selected:this.selectedServ});
          this.$refs.upgradeInfos.show();
          this.closeUpgradeVersion();
          EventBus.$emit('toast', { type: 'success', content: this.$t('DeployManagement.upgrading') });
        }else{
          EventBus.$emit('toast', { type: 'error', content: res.data.errorString });
          this.closeUpgradeVersion();
        }
      });

    },
    delDp() {
      // const selectedRecords = this.$refs.grid.getSelectedRecords();
      // const params = selectedRecords[0].id;
      this.$loading.showLoadding(this.$t('DeployManagement.deleting'));
      console.log('selectedRecords', this.deleteEnv);
      const params = {
        info: {
          processName: 'ems_micropoc',
          type: this.deleteEnv.type,
          ip: this.deleteEnv.dpIp,
          port: this.deleteEnv.dpPort,
          id: this.deleteEnv.id
        },
        vo: ''
      };

      this.axios.post('/lte/ems/env/delEnvironment.html', params).then((response) => {
        this.$loading.hideLoadding();
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Topo.delSuccess') });
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
          }
        }
      });
    },
    exportDpTemplate(item) {
      // const selectedRecords = this.$refs.grid.getSelectedRecords();
      const content = item.deploymentTemplate;
      // this.$loading.showLoadding(this.$t('SubscriberIms.exportdata'),this.$t('SubscriberIms.waitTip'));
      this.$loading.showLoadding(this.$t('DeployManagement.exporting'));
      const link = document.createElement('a');
      const blob = new Blob([content], { type: 'text/xml' });
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      const dateStr = new Date().Format('yyyy-MM-dd HH:mm');
      // const fileName = `${this.$t('SubscriberIms.user')}_${dateStr}.xml`;
      const fileName = `${this.$t('DeployManagement.dpDeployedTemplate')}_${dateStr}.xml`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$loading.hideLoadding();
    },
    closeDPEnviromentPage() {
      this.$refs.addDPEnviromentPage.close();
    },
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    getGridData() {
      const $this = this;
      this.$axios.post('/lte/ems/env/getEnvironmentList.html', {
        type: 'DP',
        page: {
          pageNo: 1,
          pageSize:200
        }
      }).then((response) => {
        const res = response.data.resultVal;
        if (response.status === 200 && res !== null) {
          //$this.data = res.result;
          const showRe = [];
          // EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          res.result.forEach(element => {
            const re = {};
            const content = JSON.parse(element.content);
            re.createTime = $this.formatDate(element.createTime);
            re.id = element.id;
            re.dpIp = content.dpIp;
            re.dpPort = content.dpPort;
            re.dpSoftVersion = content.dpSoftVersion;
            re.productVersion = content.productVersion;
            re.product = $this.productFormat(element);
            re.deploymentNorm = $this.deploymentNormFormat(element);
            re.name = element.name;
            re.content = element.content;
            re.deploymentTemplate = element.deploymentTemplate;
            re.type = element.type;
            re.productType = content.product;
            showRe.push(re);
          });
          $this.data = showRe;
        } else {
          EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
        }
      });
    },
    getDetailUEData() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOneData') });
        return false;
      }
      if (selectedRecords.length > 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOneData') });
        return false;
      }
      return true;
    },
    getChooseCount() {
    }
  },
  mounted() {
    this.getGridData();
  },
  created() {
    EventBus.$on('selectDpServe', target => {
      this.batchUpDpParam = target.param;
      this.selectedServ = target.records;
    });
  }
};
</script>
<style scoped>
  .card-control-section.basic_card_layout #weather_card.e-card {
  }

  .card-control-section.basic_card_layout #weather_card.e-card .e-card-header-caption .e-card-header-title,
  .card-control-section.basic_card_layout #weather_card.e-card .e-card-header-caption .e-card-sub-title {
    color: white;
  }

  .highcontrast .card-control-section.basic_card_layout #weather_card.e-card .e-card-header.weather_report .e-card-header-image {
    border: none;
  }

  .card-control-section.basic_card_layout #weather_card.e-card .weather_report .e-card-header-caption {
    text-align: right;
  }

  .card-control-section.basic_card_layout #weather_card.e-card .e-card-header.weather_report .e-card-header-image {
  }

  .card-control-section.basic_card_layout .col-xs-6.col-sm-6.col-lg-6.col-md-6 {
    width: 100%;
    padding: 10px;
  }

  .card-control-section.basic_card_layout .card-layout {
    margin: auto;
    max-width: 400px;
  }

  @media (min-width: 870px) {
    .card-control-section.basic_card_layout .col-xs-6.col-sm-6.col-lg-6.col-md-6 {
      width: 50%;
    }

    .card-control-section.basic_card_layout .card-layout {
      max-width: calc(100% - 40px);
    }
  }
  .e-toolbar{
    background:none!important;
  }
</style>
